import {
    FETCH_LOGGED_IN_USERS_START,
    FETCH_LOGGED_IN_USERS_SUCCESS,
    FETCH_LOGGED_IN_USERS_ERROR
} from '../../actions/admin/loggedInUsersActions';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    users: []
};

const loggedInUsersReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_LOGGED_IN_USERS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_LOGGED_IN_USERS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, users: action.users };
        }
        case FETCH_LOGGED_IN_USERS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        default:
            return state;
    }
}

export default loggedInUsersReducer;